export default {
    pmusers_reset_password: "Change Password",
    pmusers_reset_permanent: "Permanent",
    pmusers_passwords_do_not_match: "Passwords do not match",
    pmusers_the_password_has_been_reset: "We've sent a link to change the password",
    pmusers_reset_password_message: "An email will be sent to the user with a link to change the password",
}